import { connect } from 'react-redux';
import { UserProfile } from 'presentation/UserProfile';
import UserPlan from 'presentation/UserPlan';
import UserPayment from 'presentation/UserPayment';
import { UserBillingHistory } from 'presentation/UserBillingHistory';
import {
  // Profile
  getProfile,
  updateProfile,
  editProfile,
  previewProfile,

  // Payment
  getCards,
  addCard,
  makePrimaryCard,
  deleteCard,
  clearCardError,

  // Plan
  getPlan,
  selectPlan,

  // Billing History
} from 'actions/index';

const mapProfileStateToProps = state => ({
  profile: state.profile,
  networkError: state.app.error,
  email: state.session.email,
});
const mapProfileDispatchToProps = dispatch => ({
  getProfile: () => dispatch(getProfile()),
  updateProfile: payload => dispatch(updateProfile(payload)),
});
export const UserProfileContainer = connect(
  mapProfileStateToProps,
  mapProfileDispatchToProps
)(UserProfile);


const mapPlanStateToProps = state => ({
  plan: state.plan,
  networkError: state.app.error,
});
const mapPlanDispatchToProps = dispatch => ({
  getPlan: () => dispatch(getPlan()),
  selectPlan: payload => dispatch(selectPlan(payload)),
});
export const UserPlanContainer = connect(
  mapPlanStateToProps,
  mapPlanDispatchToProps
)(UserPlan);


const mapPaymentStateToProps = state => ({
  payment: state.payment,
  networkError: state.app.error,
});
const mapPaymentDispatchToProps = dispatch => ({
  getCards: () => dispatch(getCards()),
  clearCardError: () => dispatch(clearCardError()),
  addCard: payload => dispatch(addCard(payload)),
  makePrimaryCard: payload => dispatch(makePrimaryCard(payload)),
  deleteCard: payload => dispatch(deleteCard(payload)),
});
export const UserPaymentContainer = connect(
  mapPaymentStateToProps,
  mapPaymentDispatchToProps
)(UserPayment);


const mapBillingStateToProps = state => ({
  billing: state.billing,
  networkError: state.app.error,
});
// const mapBillingDispatchToProps = dispatch => ({
// });
export const UserBillingHistoryContainer = connect(
  mapBillingStateToProps,
)(UserBillingHistory);



// WEBPACK FOOTER //
// ./scripts/containers/UserContainer.jsx